import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface MediaCategory {
  id: number
  name: string
  public: number
  posts: number
  premium: number
  stories: number
  messages: number
  created_at: string
}

interface MediaCategoryStore {
  categories: MediaCategory[]
  lastFetched: number | null
  setCategories: (data: MediaCategory[]) => void
  clear: () => void // <--- standardized!
  isStale: () => boolean
}

export const useMediaCategoryStore = create<MediaCategoryStore>()(
  persist(
    (set, get) => ({
      categories: [],
      lastFetched: null,
      setCategories: (data) =>
        set({ categories: data, lastFetched: Date.now() }),
      clear: () => set({ categories: [], lastFetched: null }),
      isStale: () => {
        const ttl = 1000 * 60 * 60 * 24 // 24 hours
        const now = Date.now()
        const last = get().lastFetched
        return !last || now - last > ttl
      }
    }),
    {
      name: 'media-category-store',
      partialize: (state) => ({
        categories: state.categories,
        lastFetched: state.lastFetched,
      }),
    }
  )
)
